import { get, last } from 'lodash';
import { connect } from 'react-redux';

import BreadcrumbsComponent from 'components/CollectionBreadcrumbs';
import { BREADCRUMB_NAVIGATION_LINK_TYPES } from 'constants/breadcrumbNavigation';
import * as actions from 'state/actions';
import Catalog from 'state/selectors/catalog';
import CollectionPage from 'state/selectors/collection-page';
import BreadcrumbsUtil from 'utils/Breadcrumbs';

const mapStateToProps = state => {
  const type = BREADCRUMB_NAVIGATION_LINK_TYPES.COLLECTION;
  const handle = CollectionPage.getCollectionHandle(state);
  const parentCollection = Catalog.getParentCollection(state, handle);

  const { breadcrumbTrail } = BreadcrumbsUtil.getBreadcrumbTrail({ type, handle });

  const breadcrumbLabel = get(last(breadcrumbTrail), 'label');
  const collectionName = get(parentCollection, 'name');
  const currentCollectionTitle = breadcrumbLabel || collectionName;

  return {
    breadcrumbTrail,
    currentCollectionTitle,
  };
};

const mapDispatchToProps = dispatch => ({
  trackNavigation: url => {
    dispatch(actions.trackBreadcrumbNavigation(url));
    // Because this function will be added to an <a> tag's onClick handler, it needs to return true to not prevent navigation
    return true;
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(BreadcrumbsComponent);
